import { useEffect, useRef, type RefObject } from 'react';

/**
 * Fechar ao clicar no backdrop só é seguro quando o pointerdown começou fora do painel.
 * Evita fechar ao soltar o botão fora da modal após interação dentro (seleção de texto, arrastar do botão copiar, etc.).
 */
export function useBackdropDismissGuard(
  isActive: boolean,
  panelRef: RefObject<HTMLElement | null>,
): () => boolean {
  const pointerStartedOutsidePanelRef = useRef(false);

  useEffect(() => {
    if (!isActive) return;

    const onPointerDownCapture = (e: PointerEvent) => {
      const panel = panelRef.current;
      const { target } = e;
      if (!(target instanceof Node)) {
        pointerStartedOutsidePanelRef.current = true;
        return;
      }
      pointerStartedOutsidePanelRef.current = panel ? !panel.contains(target) : true;
    };

    window.addEventListener('pointerdown', onPointerDownCapture, true);
    return () => window.removeEventListener('pointerdown', onPointerDownCapture, true);
  }, [isActive]);

  return () => pointerStartedOutsidePanelRef.current;
}
